const LOCAL_STORAGE_KEY = {
  ACCESS_TOKEN: 'affinidi:accessToken',
  DID_TOKEN: 'affinidi:didToken',
  USER_TOKEN: 'educate:userToken',
}

export default LOCAL_STORAGE_KEY
